<template>
  <v-row>
    <v-dialog v-model="showDialog" persistent max-width="600px">
      <v-card>
        <!-- Title -->
        <v-card-title class="primary">
          <h3 class="white--text">Make A Booking</h3>
          <div class="flex-grow-1"></div>
          <v-btn outlined color="white" @click="showDialog = false">Close</v-btn>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="pa-5">
          <!-- Drop off Date & Time -->
          <v-row>
            <v-col>
              <h3 class="headline primary--text">Drop-off Date &amp; Time</h3>
            </v-col>
          </v-row>
          <v-row>
            <date-picker @change="handleInputChange" :date="bookingDate"></date-picker>
            <time-picker @change="handleInputChange"></time-picker>
          </v-row>

          <!-- Boarding / Grooming / Daycare -->
          <v-row>
            <v-col>
              <h3 class="headline primary--text pb-5">Service Requested</h3>
              <v-card>
                <v-tabs v-model="tabs" fixed-tabs>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#boardingtab" class="primary--text">Boarding</v-tab>
                  <v-tab href="#groomingtab" class="primary--text">Grooming</v-tab>
                  <v-tab href="#daycaretab" class="primary--text">Daycare</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                  <v-tab-item value="boardingtab">
                    <boarding-fields @change="handleInputChange"></boarding-fields>
                  </v-tab-item>
                  <v-tab-item value="groomingtab">
                    <grooming-fields @change="handleInputChange"></grooming-fields>
                  </v-tab-item>
                  <v-tab-item value="daycaretab">
                    <daycare-fields @change="handleInputChange"></daycare-fields>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>

          <!-- </user-fields> -->
          <v-row>
            <v-col>
              <h3 class="headline primary--text">Contact Information</h3>
              <user-fields @change="handleInputChange"></user-fields>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-5">
          <v-btn x-large outlined text @click="showDialog = false">Close</v-btn>
          <div class="flex-grow-1"></div>
          <h3 v-show="formSubmitted" class="success--text">Successfully submitted</h3>
          <h3 v-show="formError" class="error--text">Error submitting form</h3>
          <v-btn
            v-show="!formSubmitted"
            :loading="showLoadingIcon"
            x-large
            color="primary"
            @click="sendBooking()"
            :disabled="!termsChecked"
            class="ml-5"
          >Book It!</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import TimePicker from "@/components/booking/TimePicker";
import DatePicker from "@/components/booking/DatePicker";
import UserFields from "@/components/booking/UserFields";
import BoardingFields from "@/components/booking/BoardingFields";
import GroomingFields from "@/components/booking/GroomingFields";
import DaycareFields from "@/components/booking/DaycareFields";
export default {
  components: {
    TimePicker,
    DatePicker,
    UserFields,
    BoardingFields,
    GroomingFields,
    DaycareFields
  },
  props: {
    bookingDate: {
      type: String,
      default: ""
    },
    bookingTime: {
      type: String,
      default: ""
    }
  },
  watch: {
    bookingDate: function(val) {
      this.bookingDate = val;
      this.showDialog = true;

      this.formData.BookingDate = val;
    },
    bookingTime: function(val) {
      this.bookingTime = val;
      this.showDialog = true;

      this.formData.BookingTime = val;
    }
  },
  data: () => ({
    showDialog: false,
    tabs: null,
    formData: {},
    termsChecked: false,
    showLoadingIcon: false,
    formSubmitted: false,
    formError: false
  }),
  methods: {
    handleInputChange: function(fieldName, fieldVal) {
      this.formData[fieldName] = fieldVal;
      this.termsChecked = this.formData.TermsChecked;
    },
    sendBooking: async function() {
      try {
        this.showLoadingIcon = true;

        const axios = require("axios");
        await axios({
          method: "post",
          url: `https://asia-northeast1-lovepaws-homestay.cloudfunctions.net/web/api/v1.0/createBooking`,
          data: JSON.stringify(this.formData),
          timeout: 10000,
          headers: {
            "Content-Type": "application/json"
          }
        });

        this.formError = false;
        this.formSubmitted = true;

        // close after a second
        setTimeout(() => {
          this.showDialog = false;
        }, 1000);
      } catch (err) {
        this.formError = true;
        this.showLoadingIcon = false;
      }
    }
  }
};
</script>